const CLOSED_ANNOUNCEMENTS_KEY = "closed_announcement_ids"

export const setAnnouncementClosedInStorage = (id: number) => {
  const closedIds = getClosedAnnouncementIds()
  if (closedIds.includes(id.toString())) return
  closedIds.push(id.toString())
  try {
    sessionStorage.setItem(CLOSED_ANNOUNCEMENTS_KEY, closedIds.join(','))
  } catch {
  }
}

export const isAnnouncementClosed = (id: number) => {
  return getClosedAnnouncementIds().includes(id.toString())
}

const getClosedAnnouncementIds = (): string[] => {
  try {
    const item = sessionStorage.getItem(CLOSED_ANNOUNCEMENTS_KEY)
    if (item == null) return []
    return item.split(',')
  } catch {
    return []
  }
}
